<template>
    <div v-if="showCookies" id="cookie-msg" class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="cookie-text col-xs-12 col-md-8">
                    <p><span>Usage of Cookies</span><br>We would like to use cookies to better understand your use of this website. This
                        enables us to improve your future experience on our website. Detailed information
                        about the use of cookies on this website and how you can manage or withdraw your
                        consent at any time can be found in our <a href="#" @click.prevent="launchPrivacyPolicy" target="_blank">Privacy Statement</a>.</p>
                </div>
                <div class="cookie-btns col-xs-12 col-md-4">
                    <a href="" @click.prevent="accept" target="_blank">Accept</a>
                    <a href="#" @click.prevent="decline" target="_blank">Decline</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import analytics from './analytics';
export default {
    name: "Cookies",
    data: function() {
        return {
            state: true,
            analytics: analytics,
        }
    },
    created() {
        // Initialize analytics when component is created
        this.analytics.init();
    },
    computed: {
        showCookies() {
            return this.state && this.analytics.getConsentCookie() === -1;
        }
    },
    methods: {
        accept() {
            this.analytics.setOptInState(true);
            this.$analytics.enable(true);
            this.state = false;

            // Track this acceptance event
            this.trackCurrentPage();

            const route = this.$route;
            this.$analytics.trackPage(route.path, route.name, route.meta.screenClass || '');
        },
        decline: function() {
            localStorage.setItem('analytics_consent', 'false');

            this.analytics.setOptInState(false);
            this.state = false;
        },
        launchPrivacyPolicy: function() {
            this.$emit('open');
        },
        trackCurrentPage() {
            // Get current route and page information
            const route = this.$router.path || window.location.pathname;
            const pageTitle = document.title;
            const screenClass = document.querySelector('body').className || '';
            
            // Track the current page with proper title and screen class
            this.analytics.trackRoute(route, pageTitle, screenClass);
        }
    }
}
</script>

<style scoped>
#cookie-msg {
    background-color: white;
    bottom: 0;
    min-height: 127px;
    padding: 4rem 0;
    position: fixed;
    z-index: 9990; }

#cookie-msg .container {
    padding: 0 70px;
}

#cookie-msg p {
    color: #000;
    flex: 2;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 16px;
    margin-right: 4rem; }

#cookie-msg p span {
    font-weight: 700;
    text-transform: uppercase; }

.cookie-btns a {
    display: block;
    color: #003B33;
}

#cookie-msg a {
    color: #003B33;
}

@media(min-width: 768px) {
    #cookie-msg .cookie-btns {
        text-align: right;
    }
    #cookie-msg .cookie-btns a {
        margin: 1em 0 !important;
    }
}
@media(max-width: 768px) {
    #cookie-msg .cookie-btns {
        margin-top: 2rem;
    }

    #cookie-msg .cookie-btns a {
        display: flex;
        left: 0;
        width: 355px !important;
        margin: 1rem 0 0;
    }
}
</style>